module.exports = __webpack_public_path__ + "static/img/1112_phase_function_Paper_PointsHejduk_Prediction.6a0fc5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1112_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ur7z
// module chunks = 0